/* Match the mobile carousel height to the current slide's original image ratio. */
(() => {
  if (window.__dawnMobileSlideshow) return;
  window.__dawnMobileSlideshow = true;
  const mobile = matchMedia('(max-width: 749px)');
  const instances = new Map();
  function setup(component) {
    if (instances.has(component)) return;
    const slider = component.querySelector('.slideshow');
    const slides = [...component.querySelectorAll('.slideshow__slide')];
    if (!slider || !slides.length) return;
    const events = new AbortController();
    let frame = 0;
    function update() {
      if (!mobile.matches) { slider.style.removeProperty('--dawn-active-slide-height'); return; }
      const sliderRect = slider.getBoundingClientRect();
      const active = slides.reduce((best, slide) =>
        Math.abs(slide.getBoundingClientRect().left - sliderRect.left) <
        Math.abs(best.getBoundingClientRect().left - sliderRect.left) ? slide : best, slides[0]);
      const height = active.offsetHeight;
      if (height && slider.style.getPropertyValue('--dawn-active-slide-height') !== `${height}px`)
        slider.style.setProperty('--dawn-active-slide-height', `${height}px`);
    }
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
    const observer = new ResizeObserver(schedule);
    slides.forEach(slide => observer.observe(slide));
    slider.addEventListener('scroll', schedule, { passive: true, signal: events.signal });
    component.addEventListener('slideChanged', schedule, { signal: events.signal });
    component.querySelectorAll('img').forEach(img => img.addEventListener('load', schedule, { signal: events.signal }));
    mobile.addEventListener('change', schedule, { signal: events.signal });
    instances.set(component, () => { events.abort(); observer.disconnect(); cancelAnimationFrame(frame); });
    schedule();
  }
  function init() {
    for (const [component, cleanup] of instances) if (!component.isConnected) { cleanup(); instances.delete(component); }
    document.querySelectorAll('slideshow-component[data-dawn-mobile-natural="true"]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => setTimeout(init, 0));
})();
